// Catálogo compartido sin dependencias: evita ciclos entre examen, piel y escalas.
export const SEGMENTOS_EXAMEN = [
  {
    // Cabeza y cara reestructurada por dictado del fundador (2026-07-18): el
    // recorrido parte por el cráneo, sigue por pupilas (campo FIJO, ya no
    // detrás de "profundizar"), mucosas y coloración, y cierra con otros
    // hallazgos. El orden del array ES el orden de la prosa. Desorientación se
    // RETIRÓ del catálogo: eso es estado de conciencia (apertura), no un
    // hallazgo de cabeza — no restaurarla.
    id: 'cabeza', label: 'Cabeza y cara',
    hallazgos: [
      { v: 'Herida o hematoma facial', evolucion: 'tegumentario', grupo: 'craneo' },
      { v: 'Lesiones en cuero cabelludo o cara', evolucion: 'tegumentario', grupo: 'craneo' },
      { v: 'Mucosas resecas', evolucion: 'gastro', grupo: 'mucosas' },
      { v: 'Palidez de piel', evolucion: 'hemodinamia', grupo: 'mucosas' },
      { v: 'Cianosis peribucal', evolucion: 'ventilacion', red: 'B', grupo: 'mucosas' },
      // Boca separada (dictado): lesiones orales (mucositis/MDRPI se leen en
      // el texto) y placa dental (dato de cuidado, clave pre procedimientos).
      // Sin ruta hasta el 2026-08-29: una lesión de mucosa constatada no llegaba
      // a ningún sistema. Va a tegumentario, como el resto de las lesiones.
      { v: 'Lesiones en mucosa oral u orofaríngea', evolucion: 'tegumentario', grupo: 'boca' },
      { v: 'Usa placa dental', grupo: 'boca' },
      // Tubo orotraqueal visible en la boca (dictado 2026-07-18): presencia +
      // fijación como chips; el cm en comisura y el cuff van como campos (ver
      // CAMPOS_EXAMEN.cabeza). El detalle ventilatorio completo vive en la
      // evolución (rama ventilación); acá es la constatación del examen.
      { v: 'Tubo orotraqueal in situ', evolucion: 'ventilacion', grupo: 'tubo' },
      { v: 'Fijación del tubo adecuada', evolucion: 'ventilacion', grupo: 'tubo' },
      { v: 'Ictericia en escleras', evolucion: 'gastro', grupo: 'otros' },
      { v: 'Edema facial', evolucion: 'hemodinamia', grupo: 'otros' },
      { v: 'Drenaje presente', evolucion: 'invasivos', grupo: 'otros' },
    ],
  },
  {
    // Cuello con la misma forma que cabeza (dictado 2026-07-18): mismo
    // contenido, clasificado por cómo se examina (inspección → palpación →
    // piel). El orden del array ES el orden de la prosa.
    id: 'cuello', label: 'Cuello',
    hallazgos: [
      { v: 'Ingurgitación yugular', evolucion: 'hemodinamia', grupo: 'inspeccion' },
      { v: 'Desviación traqueal', evolucion: 'ventilacion', red: 'B', grupo: 'inspeccion' },
      { v: 'Aumento de volumen cervical', grupo: 'inspeccion' },
      { v: 'Adenopatías palpables', grupo: 'palpacion' },
      { v: 'Rigidez o dolor cervical', evolucion: 'neuro', grupo: 'palpacion' },
      { v: 'Herida o apósito cervical', evolucion: 'tegumentario', grupo: 'piel' },
    ],
  },
  {
    // Tórax clasificado (dictado 2026-07-18): patrón respiratorio y
    // auscultación son campos FIJOS (ver GRUPOS_SEGMENTO); la musculatura
    // accesoria se especifica (¿cuál?), los drenajes pleurales se describen
    // con chips componibles ("drenaje pleural aspirativo, oscilante, sin fuga
    // aérea") y la piel cierra. El orden del array ES el orden de la prosa.
    id: 'torax', label: 'Tórax',
    hallazgos: [
      { v: 'Uso de musculatura accesoria', evolucion: 'ventilacion', grupo: 'musculatura' },
      { v: 'Uso de musculatura abdominal', evolucion: 'ventilacion', grupo: 'musculatura' },
      { v: 'Tiraje subcostal', evolucion: 'ventilacion', grupo: 'musculatura' },
      { v: 'Tiraje intercostal', evolucion: 'ventilacion', grupo: 'musculatura' },
      { v: 'Tiraje supraclavicular', evolucion: 'ventilacion', grupo: 'musculatura' },
      { v: 'Drenaje pleural aspirativo', evolucion: 'invasivos', grupo: 'drenajes' },
      { v: 'Drenaje pleural a caída libre', evolucion: 'invasivos', grupo: 'drenajes' },
      // Los tres describen el DRENAJE, y hasta el 2026-08-29 no tenían ruta:
      // marcarlos no aportaba una sola línea a la evolución. Una FUGA AÉREA que
      // desaparece del registro es pérdida clínica grave (fístula broncopleural,
      // neumotórax que no resuelve), así que las dos van a ventilación, que es
      // donde se lee el problema; "oscilante" describe el funcionamiento del
      // dispositivo y va con él a invasivos.
      { v: 'Oscilante', evolucion: 'invasivos', grupo: 'drenajes' },
      { v: 'Con fuga aérea', evolucion: 'ventilacion', grupo: 'drenajes' },
      { v: 'Sin fuga aérea', evolucion: 'ventilacion', grupo: 'drenajes' },
      { v: 'Herida operatoria con apósitos', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Apósitos manchados', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Lesiones de piel en tórax', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Asimetría en la expansión', evolucion: 'ventilacion', grupo: 'otros' },
      { v: 'Respiración rápida y superficial', evolucion: 'ventilacion', grupo: 'otros' },
      { v: 'Tos con secreciones', evolucion: 'ventilacion', grupo: 'otros' },
    ],
  },
  {
    // Abdomen clasificado (dictado 2026-07-18): palpación, percusión y RHA
    // como campos fijos; ostomías/drenajes y piel con chips. Los chips legados
    // (distensión, dolor, RHA disminuidos) viven en "otros": son el punto de
    // aterrizaje del dictado y de los puentes — misma doctrina que tórax.
    id: 'abdomen', label: 'Abdomen',
    hallazgos: [
      { v: 'Ostomía presente', evolucion: 'gastro', grupo: 'ostomias' },
      { v: 'Drenaje abdominal presente', evolucion: 'invasivos', grupo: 'ostomias' },
      { v: 'Herida operatoria con apósitos', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Distensión abdominal', evolucion: 'gastro', grupo: 'otros' },
      { v: 'Dolor a la palpación', evolucion: 'gastro', grupo: 'otros' },
      { v: 'Ruidos hidroaéreos disminuidos', evolucion: 'gastro', grupo: 'otros' },
      { v: 'Globo vesical', evolucion: 'renal', grupo: 'otros' },
    ],
  },
  {
    // Extremidades clasificadas (dictado 2026-07-18): movilidad/fuerza/
    // sensibilidad → perfusión (pulsos descritos, llene, temperatura) →
    // edema componible (dónde + godet) → piel (equimosis, eritema,
    // flictenas, hidratación). El orden del array ES el orden de la prosa.
    id: 'eess', label: 'Extremidades superiores',
    hallazgos: [
      { v: 'Movilidad disminuida', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Debilidad o paresia', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Sensibilidad alterada', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Frialdad distal', evolucion: 'hemodinamia', grupo: 'perfusion' },
      { v: 'Llene capilar enlentecido', evolucion: 'hemodinamia', grupo: 'perfusion' },
      { v: 'Edema', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Edema localizado', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Edema bilateral', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (+)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (++)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (+++)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Equimosis', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Eritema', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Flictenas', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Piel reseca', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Lesiones de piel', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Sitio de punción con signos inflamatorios', evolucion: 'tegumentario', grupo: 'piel' },
    ],
  },
  {
    id: 'eeii', label: 'Extremidades inferiores',
    hallazgos: [
      { v: 'Movilidad disminuida', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Debilidad o paresia', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Sensibilidad alterada', evolucion: 'neuro', grupo: 'motor' },
      { v: 'Frialdad distal', evolucion: 'hemodinamia', grupo: 'perfusion' },
      { v: 'Pulsos distales disminuidos', evolucion: 'hemodinamia', red: 'C', grupo: 'perfusion' },
      { v: 'Llene capilar enlentecido', evolucion: 'hemodinamia', grupo: 'perfusion' },
      { v: 'Signos de TVP (dolor o empastamiento)', evolucion: 'hemodinamia', red: 'C', grupo: 'perfusion' },
      { v: 'Edema', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Edema localizado', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Edema bilateral', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (+)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (++)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Godet (+++)', evolucion: 'hemodinamia', grupo: 'edema' },
      { v: 'Equimosis', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Eritema', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Flictenas', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Piel reseca', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Úlcera o herida en pierna o pie', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Lesiones de piel', evolucion: 'tegumentario', grupo: 'piel' },
    ],
  },
  {
    // Genitales con la misma forma (dictado 2026-07-18): la DAI con su
    // localización (campo fijo del grupo) y el resto clasificado.
    id: 'genitales', label: 'Genitales y periné',
    hallazgos: [
      { v: 'Eritema perineal (DAI)', evolucion: 'tegumentario', grupo: 'dai' },
      { v: 'Piel macerada por humedad', evolucion: 'tegumentario', grupo: 'dai' },
      { v: 'Edema genital', grupo: 'otros' },
      { v: 'Secreción o sangrado', grupo: 'otros' },
      { v: 'Signos de infección perineal', evolucion: 'tegumentario', grupo: 'otros' },
    ],
  },
  {
    id: 'espalda', label: 'Espalda',
    hallazgos: [
      { v: 'Deformidad o desviación de columna', grupo: 'columna' },
      { v: 'Dolor a la palpación', grupo: 'columna' },
      { v: 'Eritema en zonas de apoyo', evolucion: 'tegumentario', grupo: 'piel' },
      { v: 'Lesiones de piel', evolucion: 'tegumentario', grupo: 'piel' },
    ],
  },
  {
    // EL segmento médico-legal: LPP documentada al ingreso = "venía de antes".
    // El detalle por punto de apoyo NO se pregunta uno a uno (too much, y la
    // basal ya declara el barrido): el detalle vive en el MAPA corporal, que
    // el editor de sacra ancla (resumen de lesiones + acceso directo).
    id: 'sacra', label: 'Zona sacra y puntos de apoyo',
    hallazgos: [
      { v: 'Eritema que no blanquea', evolucion: 'tegumentario', red: 'E', grupo: 'apoyo' },
      { v: 'LPP presente al recibir', evolucion: 'tegumentario', grupo: 'apoyo' },
      { v: 'Lesión por presión en desarrollo (DTPI)', evolucion: 'tegumentario', grupo: 'apoyo' },
      { v: 'LPP o eritema en talones', evolucion: 'tegumentario', grupo: 'apoyo' },
      { v: 'Piel macerada por humedad', evolucion: 'tegumentario', grupo: 'humedad' },
      { v: 'Apósito de protección instalado', evolucion: 'tegumentario', grupo: 'proteccion' },
    ],
  },
];
